import {EventEmitter, Injectable, Output} from '@angular/core';
import {environment} from '../../environments/environment';
import {MenuPosition} from '../../model/menu-position';
import {Observable} from 'rxjs';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {Dictionary} from '../../model/dictionary';
import {MasbitHttpService} from '../../common/http/masbit-http.service';
import {SearchItem} from "../../model/search-item";
import {BackendServiceMessage} from "../../model/backend-service-message";
import {UserSearchItem} from "../../model/UserSearchItem";

@Injectable()
export class TopMenuService {

  private static readonly GET_POSITIONS_URL=environment.apiUrl.concat(environment.menuUrl);
  private static readonly GET_NEW_CONTENT_PUBLISHED_SERVICE_URL = environment.apiUrl.concat(environment.getNewReportsPublishedServiceUrl);
  private static readonly DICT_CONTENT_TYPE_GETONE_BY_DICTID = environment.apiUrl.concat(environment.dictContentTypeFindOneByDictIdUrl);
  private static readonly DICT_CONTENT_TYPE_GET_BY_ID = environment.apiUrl.concat(environment.dictContentTypeFindByIddUrl);
  private static readonly USER_SEARCH = environment.apiUrl.concat(environment.userSearch);

  @Output() menuPositionClicked = new EventEmitter<MenuPosition>();
  @Output() changeSuggestion = new EventEmitter<SearchItem[]>();
  @Output() reloadSuggestions = new EventEmitter<boolean>();
  @Output() clickMenuItem = new EventEmitter<number>();

  @Output() userReportsCount = new EventEmitter<number>();

  getMenuPositions(forAdmin: boolean) {
    return this.httpClient.get<Array<{label: string, link: string, home: boolean, hint: string}>>( TopMenuService.GET_POSITIONS_URL.concat(String(forAdmin)));
  }

  getNewContentTypePublished(dateFrom : Date) : Observable<BackendServiceResponse<number, Array<string>>> {
    return this.httpClient.get<BackendServiceResponse<number, Array<string>>>(TopMenuService.GET_NEW_CONTENT_PUBLISHED_SERVICE_URL.concat(JSON.stringify(dateFrom)));
  }

  menuPositionClickedEmit(menuPosition : MenuPosition) {
    this.menuPositionClicked.emit(menuPosition);
  }

  changeSuggestionEmit(searchItem: SearchItem[]) {
    this.changeSuggestion.emit(searchItem);
  }

  getOneContentTypeById(contentTypeDictId : number) : Observable<Dictionary> {
    return this.httpClient.post<Dictionary>(TopMenuService.DICT_CONTENT_TYPE_GETONE_BY_DICTID, {dictId : contentTypeDictId});
  }

  getDictIdByContentTypeId(contentTypeIds : Array<string>) : Observable<Array<Dictionary>> {
    return this.httpClient.post<Array<Dictionary>>(TopMenuService.DICT_CONTENT_TYPE_GET_BY_ID , {id : contentTypeIds});
  }

  constructor(private httpClient: MasbitHttpService) {
  }

  setActiveMenuPosition(position : number) {
    this.clickMenuItem.emit(position);
  }
  
  deleteUserSearchItem(id: number): Observable<BackendServiceMessage<number, string>> {
    return this.httpClient.deleteWithBody<BackendServiceMessage<number, string>>(TopMenuService.USER_SEARCH, {id: id});
  }

  createUserSearchItem(searchString: string): Observable<BackendServiceResponse<number, UserSearchItem>> {
    return this.httpClient.post<BackendServiceResponse<number, UserSearchItem>>(TopMenuService.USER_SEARCH, {userTag: searchString});
  }
}
